// source: acompanha/dashboard/v1/dashboard.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.dashboard.v1.CountAmount', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.DashboardData', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.GetDashboardRequest', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.GetDashboardResponse', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.JobsSummary', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.OrdersAmount', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.SaleByDay', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.SalesByChannelAmount', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.SalesByDayAmount', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.SalesChannelAmount', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.TopPrinterSummary', null, global);
goog.exportSymbol('proto.acompanha.dashboard.v1.TransactionsSummary', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.GetDashboardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.GetDashboardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.GetDashboardRequest.displayName = 'proto.acompanha.dashboard.v1.GetDashboardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.GetDashboardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.GetDashboardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.GetDashboardResponse.displayName = 'proto.acompanha.dashboard.v1.GetDashboardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.CountAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.CountAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.CountAmount.displayName = 'proto.acompanha.dashboard.v1.CountAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.TopPrinterSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.TopPrinterSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.TopPrinterSummary.displayName = 'proto.acompanha.dashboard.v1.TopPrinterSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.JobsSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.JobsSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.JobsSummary.displayName = 'proto.acompanha.dashboard.v1.JobsSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.OrdersAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.OrdersAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.OrdersAmount.displayName = 'proto.acompanha.dashboard.v1.OrdersAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.SalesChannelAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.SalesChannelAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.SalesChannelAmount.displayName = 'proto.acompanha.dashboard.v1.SalesChannelAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.dashboard.v1.SalesByChannelAmount.repeatedFields_, null);
};
goog.inherits(proto.acompanha.dashboard.v1.SalesByChannelAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.SalesByChannelAmount.displayName = 'proto.acompanha.dashboard.v1.SalesByChannelAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.SaleByDay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.SaleByDay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.SaleByDay.displayName = 'proto.acompanha.dashboard.v1.SaleByDay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.SalesByDayAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.dashboard.v1.SalesByDayAmount.repeatedFields_, null);
};
goog.inherits(proto.acompanha.dashboard.v1.SalesByDayAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.SalesByDayAmount.displayName = 'proto.acompanha.dashboard.v1.SalesByDayAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.TransactionsSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.TransactionsSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.TransactionsSummary.displayName = 'proto.acompanha.dashboard.v1.TransactionsSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.dashboard.v1.DashboardData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.dashboard.v1.DashboardData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.dashboard.v1.DashboardData.displayName = 'proto.acompanha.dashboard.v1.DashboardData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.GetDashboardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
startDate: (f = msg.getStartDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
endDate: (f = msg.getEndDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.GetDashboardRequest;
  return proto.acompanha.dashboard.v1.GetDashboardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.GetDashboardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.GetDashboardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp start_date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.getStartDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest} returns this
*/
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest} returns this
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp end_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.getEndDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest} returns this
*/
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardRequest} returns this
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.GetDashboardRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.GetDashboardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.GetDashboardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.dashboard.v1.DashboardData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardResponse}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.GetDashboardResponse;
  return proto.acompanha.dashboard.v1.GetDashboardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.GetDashboardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardResponse}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.dashboard.v1.DashboardData;
      reader.readMessage(value,proto.acompanha.dashboard.v1.DashboardData.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.GetDashboardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.GetDashboardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.dashboard.v1.DashboardData.serializeBinaryToWriter
    );
  }
};


/**
 * optional DashboardData data = 1;
 * @return {?proto.acompanha.dashboard.v1.DashboardData}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.dashboard.v1.DashboardData} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.DashboardData, 1));
};


/**
 * @param {?proto.acompanha.dashboard.v1.DashboardData|undefined} value
 * @return {!proto.acompanha.dashboard.v1.GetDashboardResponse} returns this
*/
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.GetDashboardResponse} returns this
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.GetDashboardResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.CountAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.CountAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.CountAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
total: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalAmount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.CountAmount}
 */
proto.acompanha.dashboard.v1.CountAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.CountAmount;
  return proto.acompanha.dashboard.v1.CountAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.CountAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.CountAmount}
 */
proto.acompanha.dashboard.v1.CountAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.CountAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.CountAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.CountAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int32 total = 1;
 * @return {number}
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.CountAmount} returns this
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_amount = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.getTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.CountAmount} returns this
 */
proto.acompanha.dashboard.v1.CountAmount.prototype.setTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.TopPrinterSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.TopPrinterSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
printerUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
totalDurationMinutes: jspb.Message.getFieldWithDefault(msg, 3, 0),
durationSharePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
totalJobs: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.TopPrinterSummary;
  return proto.acompanha.dashboard.v1.TopPrinterSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.TopPrinterSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrinterUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalDurationMinutes(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDurationSharePercent(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalJobs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.TopPrinterSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.TopPrinterSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrinterUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getDurationSharePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getTotalJobs();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string printer_uuid = 1;
 * @return {string}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.getPrinterUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary} returns this
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.setPrinterUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary} returns this
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 total_duration_minutes = 3;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.getTotalDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary} returns this
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.setTotalDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double duration_share_percent = 4;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.getDurationSharePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary} returns this
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.setDurationSharePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 total_jobs = 5;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.getTotalJobs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TopPrinterSummary} returns this
 */
proto.acompanha.dashboard.v1.TopPrinterSummary.prototype.setTotalJobs = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.JobsSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.JobsSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.JobsSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
total: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalObjects: jspb.Message.getFieldWithDefault(msg, 2, 0),
inProgress: jspb.Message.getFieldWithDefault(msg, 3, 0),
completed: jspb.Message.getFieldWithDefault(msg, 4, 0),
issues: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalDurationMinutes: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalFilamentGrams: jspb.Message.getFieldWithDefault(msg, 7, 0),
totalPrintedObjects: jspb.Message.getFieldWithDefault(msg, 8, 0),
successRateObjects: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
topPrinter: (f = msg.getTopPrinter()) && proto.acompanha.dashboard.v1.TopPrinterSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.JobsSummary}
 */
proto.acompanha.dashboard.v1.JobsSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.JobsSummary;
  return proto.acompanha.dashboard.v1.JobsSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.JobsSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.JobsSummary}
 */
proto.acompanha.dashboard.v1.JobsSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalObjects(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInProgress(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompleted(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIssues(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalDurationMinutes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalFilamentGrams(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPrintedObjects(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSuccessRateObjects(value);
      break;
    case 10:
      var value = new proto.acompanha.dashboard.v1.TopPrinterSummary;
      reader.readMessage(value,proto.acompanha.dashboard.v1.TopPrinterSummary.deserializeBinaryFromReader);
      msg.setTopPrinter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.JobsSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.JobsSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.JobsSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalObjects();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getInProgress();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCompleted();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIssues();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalDurationMinutes();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getTotalFilamentGrams();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getTotalPrintedObjects();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getSuccessRateObjects();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getTopPrinter();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.acompanha.dashboard.v1.TopPrinterSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 total = 1;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 total_objects = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTotalObjects = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTotalObjects = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 in_progress = 3;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getInProgress = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setInProgress = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 completed = 4;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 issues = 5;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getIssues = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setIssues = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 total_duration_minutes = 6;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTotalDurationMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTotalDurationMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 total_filament_grams = 7;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTotalFilamentGrams = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTotalFilamentGrams = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 total_printed_objects = 8;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTotalPrintedObjects = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTotalPrintedObjects = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double success_rate_objects = 9;
 * @return {number}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getSuccessRateObjects = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.setSuccessRateObjects = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional TopPrinterSummary top_printer = 10;
 * @return {?proto.acompanha.dashboard.v1.TopPrinterSummary}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.getTopPrinter = function() {
  return /** @type{?proto.acompanha.dashboard.v1.TopPrinterSummary} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.TopPrinterSummary, 10));
};


/**
 * @param {?proto.acompanha.dashboard.v1.TopPrinterSummary|undefined} value
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
*/
proto.acompanha.dashboard.v1.JobsSummary.prototype.setTopPrinter = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.JobsSummary} returns this
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.clearTopPrinter = function() {
  return this.setTopPrinter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.JobsSummary.prototype.hasTopPrinter = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.OrdersAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.OrdersAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.OrdersAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
totalAmount: jspb.Message.getFieldWithDefault(msg, 1, 0),
cashAmount: jspb.Message.getFieldWithDefault(msg, 2, 0),
pixAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
creditCardAmount: jspb.Message.getFieldWithDefault(msg, 4, 0),
debitCardAmount: jspb.Message.getFieldWithDefault(msg, 5, 0),
bankTransferAmount: jspb.Message.getFieldWithDefault(msg, 6, 0),
barterAmount: jspb.Message.getFieldWithDefault(msg, 7, 0),
pendingPayment: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount}
 */
proto.acompanha.dashboard.v1.OrdersAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.OrdersAmount;
  return proto.acompanha.dashboard.v1.OrdersAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.OrdersAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount}
 */
proto.acompanha.dashboard.v1.OrdersAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAmount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCashAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPixAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreditCardAmount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDebitCardAmount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBankTransferAmount(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBarterAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPendingPayment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.OrdersAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.OrdersAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.OrdersAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalAmount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCashAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPixAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCreditCardAmount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getDebitCardAmount();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getBankTransferAmount();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getBarterAmount();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getPendingPayment();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int64 total_amount = 1;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getTotalAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setTotalAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 cash_amount = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getCashAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setCashAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 pix_amount = 3;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getPixAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setPixAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 credit_card_amount = 4;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getCreditCardAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setCreditCardAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 debit_card_amount = 5;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getDebitCardAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setDebitCardAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 bank_transfer_amount = 6;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getBankTransferAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setBankTransferAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 barter_amount = 7;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getBarterAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setBarterAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 pending_payment = 8;
 * @return {number}
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.getPendingPayment = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.OrdersAmount} returns this
 */
proto.acompanha.dashboard.v1.OrdersAmount.prototype.setPendingPayment = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.SalesChannelAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.SalesChannelAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.SalesChannelAmount}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.SalesChannelAmount;
  return proto.acompanha.dashboard.v1.SalesChannelAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.SalesChannelAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.SalesChannelAmount}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.SalesChannelAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.SalesChannelAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.dashboard.v1.SalesChannelAmount} returns this
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.SalesChannelAmount} returns this
 */
proto.acompanha.dashboard.v1.SalesChannelAmount.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.SalesByChannelAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.SalesByChannelAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
channelsList: jspb.Message.toObjectList(msg.getChannelsList(),
    proto.acompanha.dashboard.v1.SalesChannelAmount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.SalesByChannelAmount}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.SalesByChannelAmount;
  return proto.acompanha.dashboard.v1.SalesByChannelAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.SalesByChannelAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.SalesByChannelAmount}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.dashboard.v1.SalesChannelAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.SalesChannelAmount.deserializeBinaryFromReader);
      msg.addChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.SalesByChannelAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.SalesByChannelAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.dashboard.v1.SalesChannelAmount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SalesChannelAmount channels = 1;
 * @return {!Array<!proto.acompanha.dashboard.v1.SalesChannelAmount>}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.getChannelsList = function() {
  return /** @type{!Array<!proto.acompanha.dashboard.v1.SalesChannelAmount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.dashboard.v1.SalesChannelAmount, 1));
};


/**
 * @param {!Array<!proto.acompanha.dashboard.v1.SalesChannelAmount>} value
 * @return {!proto.acompanha.dashboard.v1.SalesByChannelAmount} returns this
*/
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.setChannelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.dashboard.v1.SalesChannelAmount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.dashboard.v1.SalesChannelAmount}
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.addChannels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.dashboard.v1.SalesChannelAmount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.dashboard.v1.SalesByChannelAmount} returns this
 */
proto.acompanha.dashboard.v1.SalesByChannelAmount.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.SaleByDay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.SaleByDay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SaleByDay.toObject = function(includeInstance, msg) {
  var f, obj = {
date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
amount: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.SaleByDay}
 */
proto.acompanha.dashboard.v1.SaleByDay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.SaleByDay;
  return proto.acompanha.dashboard.v1.SaleByDay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.SaleByDay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.SaleByDay}
 */
proto.acompanha.dashboard.v1.SaleByDay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.SaleByDay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.SaleByDay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SaleByDay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.dashboard.v1.SaleByDay} returns this
*/
proto.acompanha.dashboard.v1.SaleByDay.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.SaleByDay} returns this
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 amount = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.SaleByDay} returns this
 */
proto.acompanha.dashboard.v1.SaleByDay.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.SalesByDayAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.SalesByDayAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
salesList: jspb.Message.toObjectList(msg.getSalesList(),
    proto.acompanha.dashboard.v1.SaleByDay.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.SalesByDayAmount}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.SalesByDayAmount;
  return proto.acompanha.dashboard.v1.SalesByDayAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.SalesByDayAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.SalesByDayAmount}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.dashboard.v1.SaleByDay;
      reader.readMessage(value,proto.acompanha.dashboard.v1.SaleByDay.deserializeBinaryFromReader);
      msg.addSales(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.SalesByDayAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.SalesByDayAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.dashboard.v1.SaleByDay.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SaleByDay sales = 1;
 * @return {!Array<!proto.acompanha.dashboard.v1.SaleByDay>}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.getSalesList = function() {
  return /** @type{!Array<!proto.acompanha.dashboard.v1.SaleByDay>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.dashboard.v1.SaleByDay, 1));
};


/**
 * @param {!Array<!proto.acompanha.dashboard.v1.SaleByDay>} value
 * @return {!proto.acompanha.dashboard.v1.SalesByDayAmount} returns this
*/
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.setSalesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.dashboard.v1.SaleByDay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.dashboard.v1.SaleByDay}
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.addSales = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.dashboard.v1.SaleByDay, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.dashboard.v1.SalesByDayAmount} returns this
 */
proto.acompanha.dashboard.v1.SalesByDayAmount.prototype.clearSalesList = function() {
  return this.setSalesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.TransactionsSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.TransactionsSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.TransactionsSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
totalIncome: jspb.Message.getFieldWithDefault(msg, 1, 0),
totalOutcome: jspb.Message.getFieldWithDefault(msg, 2, 0),
netAmount: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalTransactions: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.TransactionsSummary;
  return proto.acompanha.dashboard.v1.TransactionsSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.TransactionsSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalIncome(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalOutcome(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNetAmount(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalTransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.TransactionsSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.TransactionsSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.TransactionsSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalIncome();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotalOutcome();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getNetAmount();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalTransactions();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int64 total_income = 1;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.getTotalIncome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary} returns this
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.setTotalIncome = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_outcome = 2;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.getTotalOutcome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary} returns this
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.setTotalOutcome = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 net_amount = 3;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.getNetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary} returns this
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.setNetAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_transactions = 4;
 * @return {number}
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.getTotalTransactions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.TransactionsSummary} returns this
 */
proto.acompanha.dashboard.v1.TransactionsSummary.prototype.setTotalTransactions = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.dashboard.v1.DashboardData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.dashboard.v1.DashboardData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.DashboardData.toObject = function(includeInstance, msg) {
  var f, obj = {
printersTotals: (f = msg.getPrintersTotals()) && proto.acompanha.dashboard.v1.CountAmount.toObject(includeInstance, f),
materialsTotal: (f = msg.getMaterialsTotal()) && proto.acompanha.dashboard.v1.CountAmount.toObject(includeInstance, f),
productsTotal: jspb.Message.getFieldWithDefault(msg, 3, 0),
checkoutsTotal: jspb.Message.getFieldWithDefault(msg, 4, 0),
ordersTotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
jobsSummary: (f = msg.getJobsSummary()) && proto.acompanha.dashboard.v1.JobsSummary.toObject(includeInstance, f),
ordersAmount: (f = msg.getOrdersAmount()) && proto.acompanha.dashboard.v1.OrdersAmount.toObject(includeInstance, f),
checkoutsAmount: jspb.Message.getFieldWithDefault(msg, 8, 0),
salesByChannelAmount: (f = msg.getSalesByChannelAmount()) && proto.acompanha.dashboard.v1.SalesByChannelAmount.toObject(includeInstance, f),
salesByDayAmount: (f = msg.getSalesByDayAmount()) && proto.acompanha.dashboard.v1.SalesByDayAmount.toObject(includeInstance, f),
customersTotal: jspb.Message.getFieldWithDefault(msg, 11, 0),
transactionsSummary: (f = msg.getTransactionsSummary()) && proto.acompanha.dashboard.v1.TransactionsSummary.toObject(includeInstance, f),
replacementPartsTotal: (f = msg.getReplacementPartsTotal()) && proto.acompanha.dashboard.v1.CountAmount.toObject(includeInstance, f),
maintenancesTotal: jspb.Message.getFieldWithDefault(msg, 14, 0),
quotesTotal: jspb.Message.getFieldWithDefault(msg, 15, 0),
operationalCostsMonthTotal: jspb.Message.getFieldWithDefault(msg, 16, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.dashboard.v1.DashboardData}
 */
proto.acompanha.dashboard.v1.DashboardData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.dashboard.v1.DashboardData;
  return proto.acompanha.dashboard.v1.DashboardData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.dashboard.v1.DashboardData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.dashboard.v1.DashboardData}
 */
proto.acompanha.dashboard.v1.DashboardData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.dashboard.v1.CountAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.CountAmount.deserializeBinaryFromReader);
      msg.setPrintersTotals(value);
      break;
    case 2:
      var value = new proto.acompanha.dashboard.v1.CountAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.CountAmount.deserializeBinaryFromReader);
      msg.setMaterialsTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProductsTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCheckoutsTotal(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdersTotal(value);
      break;
    case 6:
      var value = new proto.acompanha.dashboard.v1.JobsSummary;
      reader.readMessage(value,proto.acompanha.dashboard.v1.JobsSummary.deserializeBinaryFromReader);
      msg.setJobsSummary(value);
      break;
    case 7:
      var value = new proto.acompanha.dashboard.v1.OrdersAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.OrdersAmount.deserializeBinaryFromReader);
      msg.setOrdersAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCheckoutsAmount(value);
      break;
    case 9:
      var value = new proto.acompanha.dashboard.v1.SalesByChannelAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.SalesByChannelAmount.deserializeBinaryFromReader);
      msg.setSalesByChannelAmount(value);
      break;
    case 10:
      var value = new proto.acompanha.dashboard.v1.SalesByDayAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.SalesByDayAmount.deserializeBinaryFromReader);
      msg.setSalesByDayAmount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomersTotal(value);
      break;
    case 12:
      var value = new proto.acompanha.dashboard.v1.TransactionsSummary;
      reader.readMessage(value,proto.acompanha.dashboard.v1.TransactionsSummary.deserializeBinaryFromReader);
      msg.setTransactionsSummary(value);
      break;
    case 13:
      var value = new proto.acompanha.dashboard.v1.CountAmount;
      reader.readMessage(value,proto.acompanha.dashboard.v1.CountAmount.deserializeBinaryFromReader);
      msg.setReplacementPartsTotal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaintenancesTotal(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuotesTotal(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOperationalCostsMonthTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.dashboard.v1.DashboardData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.dashboard.v1.DashboardData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.dashboard.v1.DashboardData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrintersTotals();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.dashboard.v1.CountAmount.serializeBinaryToWriter
    );
  }
  f = message.getMaterialsTotal();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.dashboard.v1.CountAmount.serializeBinaryToWriter
    );
  }
  f = message.getProductsTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCheckoutsTotal();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOrdersTotal();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getJobsSummary();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.acompanha.dashboard.v1.JobsSummary.serializeBinaryToWriter
    );
  }
  f = message.getOrdersAmount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.acompanha.dashboard.v1.OrdersAmount.serializeBinaryToWriter
    );
  }
  f = message.getCheckoutsAmount();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSalesByChannelAmount();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.acompanha.dashboard.v1.SalesByChannelAmount.serializeBinaryToWriter
    );
  }
  f = message.getSalesByDayAmount();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.acompanha.dashboard.v1.SalesByDayAmount.serializeBinaryToWriter
    );
  }
  f = message.getCustomersTotal();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getTransactionsSummary();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.acompanha.dashboard.v1.TransactionsSummary.serializeBinaryToWriter
    );
  }
  f = message.getReplacementPartsTotal();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.acompanha.dashboard.v1.CountAmount.serializeBinaryToWriter
    );
  }
  f = message.getMaintenancesTotal();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getQuotesTotal();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getOperationalCostsMonthTotal();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
};


/**
 * optional CountAmount printers_totals = 1;
 * @return {?proto.acompanha.dashboard.v1.CountAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getPrintersTotals = function() {
  return /** @type{?proto.acompanha.dashboard.v1.CountAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.CountAmount, 1));
};


/**
 * @param {?proto.acompanha.dashboard.v1.CountAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setPrintersTotals = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearPrintersTotals = function() {
  return this.setPrintersTotals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasPrintersTotals = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CountAmount materials_total = 2;
 * @return {?proto.acompanha.dashboard.v1.CountAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getMaterialsTotal = function() {
  return /** @type{?proto.acompanha.dashboard.v1.CountAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.CountAmount, 2));
};


/**
 * @param {?proto.acompanha.dashboard.v1.CountAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setMaterialsTotal = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearMaterialsTotal = function() {
  return this.setMaterialsTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasMaterialsTotal = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 products_total = 3;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getProductsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setProductsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 checkouts_total = 4;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getCheckoutsTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setCheckoutsTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 orders_total = 5;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getOrdersTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setOrdersTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional JobsSummary jobs_summary = 6;
 * @return {?proto.acompanha.dashboard.v1.JobsSummary}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getJobsSummary = function() {
  return /** @type{?proto.acompanha.dashboard.v1.JobsSummary} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.JobsSummary, 6));
};


/**
 * @param {?proto.acompanha.dashboard.v1.JobsSummary|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setJobsSummary = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearJobsSummary = function() {
  return this.setJobsSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasJobsSummary = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional OrdersAmount orders_amount = 7;
 * @return {?proto.acompanha.dashboard.v1.OrdersAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getOrdersAmount = function() {
  return /** @type{?proto.acompanha.dashboard.v1.OrdersAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.OrdersAmount, 7));
};


/**
 * @param {?proto.acompanha.dashboard.v1.OrdersAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setOrdersAmount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearOrdersAmount = function() {
  return this.setOrdersAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasOrdersAmount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 checkouts_amount = 8;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getCheckoutsAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setCheckoutsAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional SalesByChannelAmount sales_by_channel_amount = 9;
 * @return {?proto.acompanha.dashboard.v1.SalesByChannelAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getSalesByChannelAmount = function() {
  return /** @type{?proto.acompanha.dashboard.v1.SalesByChannelAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.SalesByChannelAmount, 9));
};


/**
 * @param {?proto.acompanha.dashboard.v1.SalesByChannelAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setSalesByChannelAmount = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearSalesByChannelAmount = function() {
  return this.setSalesByChannelAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasSalesByChannelAmount = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SalesByDayAmount sales_by_day_amount = 10;
 * @return {?proto.acompanha.dashboard.v1.SalesByDayAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getSalesByDayAmount = function() {
  return /** @type{?proto.acompanha.dashboard.v1.SalesByDayAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.SalesByDayAmount, 10));
};


/**
 * @param {?proto.acompanha.dashboard.v1.SalesByDayAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setSalesByDayAmount = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearSalesByDayAmount = function() {
  return this.setSalesByDayAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasSalesByDayAmount = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int32 customers_total = 11;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getCustomersTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setCustomersTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional TransactionsSummary transactions_summary = 12;
 * @return {?proto.acompanha.dashboard.v1.TransactionsSummary}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getTransactionsSummary = function() {
  return /** @type{?proto.acompanha.dashboard.v1.TransactionsSummary} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.TransactionsSummary, 12));
};


/**
 * @param {?proto.acompanha.dashboard.v1.TransactionsSummary|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setTransactionsSummary = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearTransactionsSummary = function() {
  return this.setTransactionsSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasTransactionsSummary = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional CountAmount replacement_parts_total = 13;
 * @return {?proto.acompanha.dashboard.v1.CountAmount}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getReplacementPartsTotal = function() {
  return /** @type{?proto.acompanha.dashboard.v1.CountAmount} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.dashboard.v1.CountAmount, 13));
};


/**
 * @param {?proto.acompanha.dashboard.v1.CountAmount|undefined} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
*/
proto.acompanha.dashboard.v1.DashboardData.prototype.setReplacementPartsTotal = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.clearReplacementPartsTotal = function() {
  return this.setReplacementPartsTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.hasReplacementPartsTotal = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 maintenances_total = 14;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getMaintenancesTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setMaintenancesTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 quotes_total = 15;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getQuotesTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setQuotesTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 operational_costs_month_total = 16;
 * @return {number}
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.getOperationalCostsMonthTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.dashboard.v1.DashboardData} returns this
 */
proto.acompanha.dashboard.v1.DashboardData.prototype.setOperationalCostsMonthTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


goog.object.extend(exports, proto.acompanha.dashboard.v1);
